import {
  Box,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Typography,
} from '@mui/material';
import type { ReportGroupBy } from '../../types/report';
import { PRESETS, type PresetKey } from './useReportDateRange';

interface ReportDateRangeControlsProps {
  preset: PresetKey;
  onPresetChange: (event: unknown, value: PresetKey | null) => void;
  from: string;
  to: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
  groupBy?: ReportGroupBy;
  onGroupByChange?: (value: ReportGroupBy) => void;
}

export function ReportDateRangeControls({
  preset,
  onPresetChange,
  from,
  to,
  onFromChange,
  onToChange,
  groupBy,
  onGroupByChange,
}: ReportDateRangeControlsProps) {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
        <Box>
          <Typography variant="caption" color="text.secondary" display="block">
            Період
          </Typography>
          <ToggleButtonGroup value={preset} exclusive size="small" onChange={onPresetChange}>
            {PRESETS.map(p => (
              <ToggleButton key={p.key} value={p.key}>{p.label}</ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>

        {preset === 'custom' && (
          <>
            <TextField
              type="date"
              label="Від"
              size="small"
              value={from}
              onChange={e => onFromChange(e.target.value)}
              slotProps={{ inputLabel: { shrink: true } }}
            />
            <TextField
              type="date"
              label="До"
              size="small"
              value={to}
              onChange={e => onToChange(e.target.value)}
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </>
        )}

        {groupBy !== undefined && onGroupByChange && (
          <Box>
            <Typography variant="caption" color="text.secondary" display="block">
              Групування
            </Typography>
            <ToggleButtonGroup
              value={groupBy}
              exclusive
              size="small"
              onChange={(_, value) => value && onGroupByChange(value)}
            >
              <ToggleButton value="day">День</ToggleButton>
              <ToggleButton value="week">Тиждень</ToggleButton>
              <ToggleButton value="month">Місяць</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        )}
      </Box>
    </Paper>
  );
}
